<div class="flex justify-end">
    <button nz-button nzType="primary" (click)="openAddChecklist()"><i nz-icon nzType="plus" class="mr-1"></i>Add
        Document Group
    </button>
</div>

<div class="space-y-4 my-4">
    <nz-card *ngFor="let cl of checklists">
        <div class="flex items-center justify-between mb-3">
            <h3 class="text-base font-semibold m-0">{{ cl.name }}</h3>
            <button nz-button nzType="primary" nzSize="small" (click)="openAddRowFor(cl.name)">
                <i nz-icon nzType="plus" class="mr-1"></i>Add Row
            </button>
        </div>
        <nz-table [nzData]="cl.rows" [nzFrontPagination]="false" [nzShowPagination]="false" nzSize="small" [nzBordered]="false" [nzTableLayout]="'fixed'">
            <thead>
                <tr>
                    <th style="text-align:center" nzWidth="150px">Title</th>
                    <th style="text-align:center" nzWidth="120px">Mandatory</th>
                    <th style="text-align:center" nzWidth="200px">Trigger Event</th>
                    <th style="text-align:center" nzWidth="150px">Max Attachments</th>
                    <th style="text-align:center" nzWidth="180px">Allowed File Types</th>
                    <th style="text-align:center" nzWidth="120px">Max Size (MB)</th>
                    <th style="text-align:center" nzWidth="120px">Action</th>
                </tr>
            </thead>
            <tbody>
                <tr *ngFor="let row of cl.rows; let idx = index">
                    <td style="text-align:center">{{ row.title }}</td>
                    <td style="text-align:center">{{ row.mandatory ? 'True' : 'False' }}</td>
                    <td style="text-align:center">
                        <span *ngFor="let t of row.triggerEvent; let last = last">{{ t }}<span *ngIf="!last">, </span></span>
                    </td>
                    <td style="text-align:center">{{ row.maxAttachments }}</td>
                    <td style="text-align:center">
                        <span *ngFor="let t of row.allowedFileType; let last = last">{{ t }}<span *ngIf="!last">,
                            </span></span>
                    </td>
                    <td style="text-align:center">{{ row.maxSizeMb }}</td>
                    <td style="text-align:center">
                        <button nz-button nzType="text" nzSize="small" class="mr-2 text-blue-600 hover:text-blue-700"
                            nz-tooltip nzTooltipTitle="Edit" nzTooltipColor="#ffffff" [nzTooltipOverlayStyle]="{'color': '#000000'}"
                            (click)="openEditRow(cl.name, idx)">
                            <i nz-icon nzType="edit" nzTheme="outline" class="text-blue-600"></i>
                        </button>
                        <button nz-button nzType="text" nzDanger nzSize="small"
                            nz-tooltip nzTooltipTitle="Delete" nzTooltipColor="#ffffff" [nzTooltipOverlayStyle]="{'color': '#000000'}"
                            (click)="deleteRow(cl.name, idx)">
                            <i nz-icon nzType="delete" nzTheme="outline"></i>
                        </button>
                    </td>
                </tr>
            </tbody>
        </nz-table>
    </nz-card>
</div>

<div class="flex justify-end">
<button nz-button nzType="primary" nzSize="small" (click)="submitChanges()">
    Submit Changes
</button>
</div>
<nz-modal [(nzVisible)]="isAddChecklistVisible" nzTitle="Add Document Group" (nzOnCancel)="handleAddChecklistCancel()" [nzCloseOnNavigation]="true" [nzMaskClosable]="false" nzCentered>
  <ng-container *nzModalContent>
    <form nz-form nzLayout="vertical" [formGroup]="addChecklistForm" class="grid grid-cols-1 gap-y-4">
      <nz-form-item class="w-full mb-0">
        <nz-form-label class="text-left" nzRequired nzFor="checklist_name">Group Name</nz-form-label>
        <nz-form-control [nzErrorTip]="'Group Name is required'">
          <nz-select id="checklist_name" formControlName="checklist_name" nzPlaceHolder="Select Group">
            <nz-option nzValue="Trip" nzLabel="Trip" [nzDisabled]="isGroupNameDisabled('Trip')"></nz-option>
            <nz-option nzValue="Leg" nzLabel="Leg" [nzDisabled]="isGroupNameDisabled('Leg')"></nz-option>
          </nz-select>
        </nz-form-control>
      </nz-form-item>

      <nz-form-item class="w-full mb-0">
        <nz-form-label class="text-left" nzRequired nzFor="trigger_event">Trigger Event</nz-form-label>
        <nz-form-control>
          <nz-select
            id="trigger_event"
            formControlName="trigger_event"
            nzMode="tags"
            nzPlaceHolder="Enter or select trigger events"
            class="w-full"
          >
            <nz-option *ngFor="let option of TRIGGER_EVENT_OPTIONS" [nzLabel]="option" [nzValue]="option"></nz-option>
          </nz-select>
        </nz-form-control>
      </nz-form-item>

      <nz-form-item class="w-full mb-0">
        <nz-form-label class="text-left" nzRequired nzFor="title">Field Name</nz-form-label>
        <nz-form-control [nzValidateStatus]="addChecklistForm.controls['title']" [nzErrorTip]="'Title is required'">
          <input nz-input id="title" formControlName="title" placeholder="Enter Title" />
        </nz-form-control>
      </nz-form-item>

      <nz-form-item class="w-full mb-0">
        <nz-form-label class="text-left" nzRequired nzFor="mandatory">Required</nz-form-label>
        <nz-form-control>
          <nz-select id="mandatory" formControlName="mandatory" nzPlaceHolder="Select">
            <nz-option [nzValue]="true" nzLabel="Yes"></nz-option>
            <nz-option [nzValue]="false" nzLabel="No"></nz-option>
          </nz-select>
        </nz-form-control>
      </nz-form-item>

      <nz-form-item class="w-full mb-0">
        <nz-form-label class="text-left" nzRequired nzFor="max_attachments">Max Number of Attachments allowed</nz-form-label>
        <nz-form-control [nzValidateStatus]="addChecklistForm.controls['max_attachments']" [nzErrorTip]="'Valid integer is required'">
          <input nz-input id="max_attachments" formControlName="max_attachments" placeholder="e.g. 3" />
        </nz-form-control>
      </nz-form-item>

      <nz-form-item class="w-full mb-0">
        <nz-form-label class="text-left" nzRequired nzFor="allowed_file_type">Allowed File Types</nz-form-label>
        <nz-form-control [nzValidateStatus]="addChecklistForm.controls['allowed_file_type']" [nzErrorTip]="'File type is required'">
          <nz-select id="allowed_file_type" formControlName="allowed_file_type" nzMode="multiple" nzPlaceHolder="Select one or more">
            <nz-option nzValue="ALL" nzLabel="All"></nz-option>
            <nz-option nzValue="PDF" nzLabel="PDF"></nz-option>
            <nz-option nzValue="DOCX" nzLabel="DOCX"></nz-option>
            <nz-option nzValue="XLSX" nzLabel="XLSX"></nz-option>
            <nz-option nzValue="JPG" nzLabel="JPG"></nz-option>
            <nz-option nzValue="PNG" nzLabel="PNG"></nz-option>
          </nz-select>
        </nz-form-control>
      </nz-form-item>

      <nz-form-item class="w-full mb-0">
        <nz-form-label class="text-left" nzRequired nzFor="max_size_mb">Maximum Size Allowed in MB</nz-form-label>
        <nz-form-control [nzValidateStatus]="addChecklistForm.controls['max_size_mb']" [nzErrorTip]="'Valid integer is required'">
          <input nz-input id="max_size_mb" formControlName="max_size_mb" placeholder="e.g. 10" />
        </nz-form-control>
      </nz-form-item>
    </form>
  </ng-container>
  <ng-container *nzModalFooter>
    <button nz-button nzType="default" (click)="handleAddChecklistCancel()">Cancel</button>
    <button nz-button nzType="primary" (click)="submitAddChecklist()">Save</button>
  </ng-container>
</nz-modal>


